// frontend/src/utils/relativeTime.js
//
// "2m ago" without a date library — the elapsed time bucketed into four
// i18n strings under `common.relativeTime`. One home for every surface that
// wants a "how long ago" beside a timestamp (connector activity, Store
// Activity), so the buckets and the abbreviations cannot drift apart.
//
// Reads the clock at call time; callers re-render to refresh it.

export function relativeTime(iso, t) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const secs = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (secs < 60) return t('common.relativeTime.justNow');
  const mins = Math.round(secs / 60);
  if (mins < 60) return t('common.relativeTime.minutesAgo', { count: mins });
  const hours = Math.round(mins / 60);
  if (hours < 24) return t('common.relativeTime.hoursAgo', { count: hours });
  return t('common.relativeTime.daysAgo', { count: Math.round(hours / 24) });
}
